import React from 'react';
const bonuses = [{
  emoji: '⚖️',
  title: 'Guida ai Carichi e Dosaggio',
  desc: 'Quante serie e ripetizioni in base a ogni obiettivo.'
}, {
  emoji: '📅',
  title: 'Piano Annuale Express',
  desc: 'Una tabella di marcia pronta per organizzare la tua agenda annuale.'
}, {
  emoji: '✅',
  title: 'Kit di Autovalutazione',
  desc: 'Schede per far misurare alle allieve i propri progressi.'
}, {
  emoji: '🎵',
  title: 'Playlists "Energy & Flow"',
  desc: 'Musica curata per il ritmo esatto delle tue lezioni.'
}, {
  emoji: '🏆',
  title: 'Certificati di Risultato',
  desc: 'Da consegnare alle allieve al passaggio di livello (fondamentale per la fidelizzazione!).'
}, {
  emoji: '🤝',
  title: 'Kit Adattamenti Inclusivi',
  desc: 'Variazioni semplificate per chi ha bisogno di un ritmo ridotto.'
}];
export function BonusSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-10">
      <div className="max-w-4xl mx-auto" data-id="element-11">
        <div className="text-center mb-14" data-id="element-12">
          <span className="text-4xl mb-4 block" data-id="element-13">🔥</span>
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-3 tracking-tight" data-id="element-14">
            6 Bonus Inclusi
          </h2>
          <p className="text-text-sec text-lg sm:text-xl font-medium mb-2" data-id="element-15">
            Valore €49 —{' '}
            <span className="text-primary font-bold" data-id="element-16">GRATIS OGGI</span>
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-17">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white rounded-2xl border border-border-light p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-5 transition-all hover:-translate-y-1 hover:border-primary/30 hover:shadow-[0_8px_20px_rgba(201,137,155,0.08)] group" data-id="element-18">
              {/* Emoji Badge */}
              <div className="w-12 h-12 rounded-xl bg-bg-alt border border-border-light flex items-center justify-center flex-shrink-0 text-2xl group-hover:bg-primary/10 transition-colors" data-id="element-19">
                {bonus.emoji}
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0" data-id="element-20">
                <h4 className="text-text-main font-bold text-base sm:text-lg mb-1" data-id="element-21">
                  {bonus.title}
                </h4>
                <p className="text-text-sec text-sm leading-relaxed" data-id="element-22">
                  {bonus.desc}
                </p>
              </div>

              {/* GRATIS badge */}
              <span className="bg-primary/10 text-primary border border-primary/20 px-2 py-1 rounded-md font-bold text-xs flex-shrink-0" data-id="element-23">
                GRATIS
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}